import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import {
  FDBox, FDCallToActionButton, FDCard, FDStack,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import { noop } from 'lodash';
import MeetingActionButton from './MeetingActionButton';
import RescheduleMeeting from './RescheduleMeeting';
import MeetingInfoDetail from './MeetingInfoDetail';
import MeetingTimeDetail from './MeetingTimeDetail';

const useStyles = buildUseStyles('MeetingCard', () => ({
  muted: {
    opacity: 0.5,
  },
}));

const MeetingCard = ({
  meeting,
  pastMeeting,
  refreshMeetings,
}) => {
  const classes = useStyles();
  // Meeting Data
  const startTime = meeting.attr('startTime');
  const endTime = meeting.attr('endTime');
  const meetingTitle = meeting.attr('title');
  const agendaResource = meeting
    .attr('agendas')
    .resources()
    .list()
    .find((item) => item.attr('messageType') === (pastMeeting ? 'follow-up' : 'agenda'));
  const isMobile = useMobileLayout();

  const showJoinBtn = meeting.attr('link') && !pastMeeting;

  return (
    <FDBox paddingY={1}>
      <FDCard>
        <div test={'my-meetings-meeting-card'} className={pastMeeting ? classes.muted : undefined}>
          <FDBox padding={2}>
            <FDStack
              spacing={2}
              wrap={!isMobile}
              direction={isMobile ? 'column' : 'row'}
              justifyContent={isMobile ? undefined : 'space-between'}
              alignItems={isMobile ? undefined : 'center'}
            >
              <MeetingInfoDetail
                meetingTitle={meetingTitle}
                organizerName={meeting.attr('organizerName')}
                organizerProfileImage={meeting.relationship(fr.relationships.organizerProfileImage.name)?.link('related').url()}
              />
              <div>
                <MeetingTimeDetail
                  startTime={startTime}
                  endTime={endTime}
                />
                {meeting.withRelationship(fr.relationships.rescheduleMeeting.name,
                  (rel) => (
                    <RescheduleMeeting
                      relationship={rel}
                      meetingResource={meeting}
                      refreshMeetings={refreshMeetings}
                    />
                  ),
                  () => null)}
              </div>
              {(agendaResource || showJoinBtn)
                ? (
                  <FDStack wrap spacing={1}>
                    {showJoinBtn && (
                      <FDCallToActionButton
                        icon="videocam"
                        label="Join Meeting"
                        onClick={() => window.open((meeting.attr('link')), '_blank').focus()}
                      />
                    )}
                    {agendaResource && (
                      <MeetingActionButton
                        isPastMeeting={pastMeeting}
                        agendaResource={agendaResource}
                      />
                    )}
                  </FDStack>
                )
                : null}
            </FDStack>
          </FDBox>
        </div>
      </FDCard>
    </FDBox>
  );
};

MeetingCard.propTypes = {
  meeting: PropTypes.object.isRequired,
  pastMeeting: PropTypes.bool,
  refreshMeetings: PropTypes.func,
};

MeetingCard.defaultProps = {
  pastMeeting: false,
  refreshMeetings: noop,
};

export default MeetingCard;
